/* eslint-disable consistent-return */
/* eslint-disable no-param-reassign */
/* eslint-disable no-underscore-dangle */
import axios from "axios";
import { useHistory } from "react-router-dom";
import qs from 'qs';
import LocalStorageService from "../services/storage/LocalStorageService";
import getClientId from '../hooks/auth/clientIdHook';
import useClientApiUrl from "../hooks/clientApiUrlHook";
const localStorageService = LocalStorageService.getService();

const centralApiInstance = axios.create({
    baseURL: useClientApiUrl()
});

// instance.interceptors.request...
// Add a request interceptor
centralApiInstance.interceptors.request.use(
    config => {
        const token = localStorageService.getAccessToken();
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        const pageTitle = window.TitleOfPage;
        if (pageTitle) {
            config.headers['PageTitle'] = pageTitle;
        }
        config.headers['Content-Type'] = 'application/json';
        return config;
    },
    error => {
        Promise.reject(error)
    });



// Add a response interceptor

centralApiInstance.interceptors.response.use((response) => response, (error) => {
    const originalRequest = error.config;

    if (error.response.status === 401 && originalRequest.url ===
        `${process.env.REACT_APP_IDN_BASE_URL}connect/token`) {
        const history = useHistory();
        history.push('user/signin');
        return Promise.reject(error);
    }

    if (error.response.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;
        const refreshToken = localStorageService.getRefreshToken();

        const axiosConfig = {
            baseURL: process.env.REACT_APP_IDN_BASE_URL,
            timeout: 30000,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        };

        const requestData = {
            client_id: getClientId(),
            client_secret: process.env.REACT_APP_API_CLIENT_SECRET,
            grant_type: 'refresh_token',
            refresh_token: refreshToken
        };

        return axios.post('connect/token', qs.stringify(requestData), axiosConfig)
            .then(res => {
                if (res.status === 201 || res.status === 200) {
                    localStorageService.setToken(res.data);
                    centralApiInstance.defaults.headers.common.Authorization = `Bearer ${localStorageService.getAccessToken()}`;
                    return centralApiInstance(originalRequest);
                }
            });
    }
    return Promise.reject(error);
});

export default centralApiInstance;
